import React from "react";
import Header from "./tvShows/components/Header/Header";
import { TvContextProvider } from "./tvShows/contexts/tvContext.js";
import Body from "./tvShows/components/Body/Body";
import Search from "./tvShows/components/Search/Search";
import Slider from "./tvShows/components/Slider/Slider.js";
import { motion } from "framer-motion";

function TvShows(props) {
  const containerVariants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: { delay: 0.5, duration: 1.5 },
    },
    exit: {
      x: "-100vw",
      transition: { ease: "easeInOut", duration: 1.5 },
    },
  };

  return (
    <TvContextProvider>
      <motion.div
        style={{
          maxWidth: "1000px",
          minWidth: "50%",
          margin: "0 auto",
        }}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "1.5em",
            fontWeight: "bolder",
            color: "white",
            letterSpacing: "0.1rem",
            fontFamily: "Oswald, sans-serif",
          }}
        >
          TRENDING SHOWS
        </h2>
        <Header />
        <br />
        <Body />
        <br />
        <Search />
        <br />
        <Slider />
        <br />
      </motion.div>
    </TvContextProvider>
  );
}
export default TvShows;
